import styled from 'styled-components';

import { Image } from 'components/image';
import { InfoBlock } from 'components/info-block';
import { DeleteButtonWithRef } from 'components/specified-buttons';

export const Block = styled(InfoBlock)`
  box-shadow: 0px 2px 8px 0px #2930420f;
`;

export const StyledDeleteButtonWithRef = styled(DeleteButtonWithRef)`
  flex-shrink: 0;
`;

export const StyledImage = styled(Image)`
  flex-shrink: 0;
  border-radius: 16px;
`;
